const pencilLogoText = 'Pencil Spaces';

/**
 * Maximum allowed length for entity descriptions across the application
 */
const MAX_ENTITY_DESCRIPTION_LENGTH = 500;

/** Milliseconds in one minute, for time-unit conversions. */
const MINUTE_IN_MILLIS = 60000;

/**
 * Grace margin in milliseconds for event timing calculations.
 * Used to handle network latency, clock synchronization issues, and timer precision.
 * Applied when determining if events should be considered "active" or when timers might run early.
 */
const EVENT_TIMING_GRACE_MARGIN_MS = 500;

/**
 * Maximum allowed length for chat messages.
 *
 * Rationale for 1,500:
 * - Slack limit: ~12,000
 * - Zoom limit: 1,038
 * - Teams behavior: No clear limit but performance issues at very large inputs.
 * - 1,500 provides a reasonable balance between allowing detailed messages and preventing performance issues.
 */
const CHAT_MESSAGE_MAX_LENGTH = 1500;

export {
  pencilLogoText,
  MAX_ENTITY_DESCRIPTION_LENGTH,
  MINUTE_IN_MILLIS,
  EVENT_TIMING_GRACE_MARGIN_MS,
  CHAT_MESSAGE_MAX_LENGTH,
};
